import { Component, Input, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgTemplateOutlet } from '@angular/common';

export interface TooltipElement {
	label: string;
	value: string;
	bold?: boolean;
}

@Component({
	selector: 'app-tooltip',
	templateUrl: './tooltip.component.html',
	styleUrls: ['./tooltip.component.scss'],
	imports: [OverlayModule, NgTemplateOutlet],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
	@Input()
	singleColumnTooltip?: string[];

	@Input()
	multiColumnTooltip?: TooltipElement[];

	@Input()
	tooltipClass?: string;

	@Input()
	template?: TemplateRef<any>;
}
